import i18n from "i18next";

export function columnsTermsOfPayment() {
  return [
    {
      id: "note_short",
      label: i18n.t("column.short_description"),
      minWidth: 120,
      maxWidth: 150,
      align: "left",
    },
    {
      id: "note_description",
      label: i18n.t("column.description"),
      minWidth: 200,
      maxWidth: 600,
      align: "left",
    },
  ];
}
